import api from './api';

const exportService = {
  /**
   * Download a CSV export file
   * @param {string} exportType - The type of export (users, orders, products, etc.)
   * @returns {Promise} - Downloads the file
   */
  downloadExport: async (exportType) => {
    try {
      const response = await api.get(`/admin/export/${exportType}/`, {
        responseType: 'blob',
      });

      // Create a download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      // Get filename from content-disposition header or use default
      const contentDisposition = response.headers['content-disposition'];
      let filename = `${exportType}_export.csv`;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to download export',
      };
    }
  },

  // Convenience methods for each export type
  exportUsers: () => exportService.downloadExport('users'),
  exportOrders: () => exportService.downloadExport('orders'),
  exportProducts: () => exportService.downloadExport('products'),
  exportPartners: () => exportService.downloadExport('partners'),
  exportPets: () => exportService.downloadExport('pets'),
  exportAppointments: () => exportService.downloadExport('appointments'),
  exportServices: () => exportService.downloadExport('services'),
  exportInventory: () => exportService.downloadExport('inventory'),
};

export default exportService;
